<template>
  <section>
    <el-form :inline="true" :model="dataForm" ref="lineForm">
      <el-form-item label="组织架构">
        <TenantCustomersSelectVue v-model="dataForm.DepartmentId" style="width: 220px"></TenantCustomersSelectVue>
      </el-form-item>
      <el-form-item label="客户名称:" prop="CompanyName">
        <el-input v-model="dataForm.CompanyName" placeholder="请输入客户公司名称" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="商户ID:" prop="MchId">
        <el-input v-model="dataForm.MchId" placeholder="请输入商户ID"></el-input>
      </el-form-item> -->
      <el-form-item label="日期:" prop="CreationTime">
        <el-date-picker v-model="dataForm.CreationTime" type="date" placeholder="选择日期" :clearable="false"
          :editable="false" @keydown.enter.native.stop @keydown.native.prevent :default-value="new Date()">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="() => {
      page = 1;
      handleGetDataList();
    }" type="primary" >查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="dataList" v-loading="dataListLoading" ref="table" class="custom-tbl" style="width: 100%">
      <el-table-column align="center" prop="DepartmentName" label="组织架构"></el-table-column>
      <!-- <el-table-column align="center" prop="MchId" label="商户ID"></el-table-column> -->
      <el-table-column align="center" prop="CompanyName" label="客户名称"></el-table-column>
      <el-table-column align="center" prop="Count" label="过滤总数"></el-table-column>
      <el-table-column align="center" prop="BlockingRate" label="拦截率"></el-table-column>
      <el-table-column align="center" prop="BlackListCount" label="黑名单数"></el-table-column>
      <el-table-column align="center" prop="BlackListRate" label="黑名单率"></el-table-column>
      <el-table-column align="center" prop="OverclockingCount" label="超频数"></el-table-column>
      <el-table-column align="center" prop="OverclockingRate" label="超频率"></el-table-column>
    </el-table>
    <el-pagination @size-change="pageSizeChangeHandle1" @current-change="pageCurrentChangeHandle1" :current-page="page"
      :page-sizes="pageSizes" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"
      style="float: right; margin-top: 15px">
    </el-pagination>
  </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import moment from "moment";
const CreationTime = moment(new Date()).format("yyyy-MM-DD");
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
export default {
  mixins: [viewModule],
  components: { TenantCustomersSelectVue },
  data() {
    return {
      dataForm: {
        Caller: "",
        Callee: "",
        CreationTime: CreationTime,
        DepartmentId: "", //组织架构id
        CompanyName: "",//客户公司名称
        MchId: ""
      },
      mixinViewModuleOptions: {
        requestMethod: "post",
        getDataListIsPage: true,
        getDataListURL: "/api/FilterQueryLog/PostMCHBlockingListCharts",
        deleteURL: "",
      },
    };
  },
  methods: {
    pageSizeChangeHandle1(val) {
      this.page = 1
      this.limit = val
      this.handleGetDataList()
    },
    pageCurrentChangeHandle1(val) {
      this.page = val
      this.handleGetDataList()
    },
    handleGetDataList() {
      this.query();
    }
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
